export const declineObjectWord = (count: number): string => {
  const lastDigit = count % 10
  const lastTwoDigits = count % 100

  if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
    return 'объектов'
  }

  if (lastDigit === 1) {
    return 'объект'
  }

  if (lastDigit >= 2 && lastDigit <= 4) {
    return 'объекта'
  }

  return 'объектов'
}
